module.exports = __webpack_public_path__ + "img/4.05a9ef62.png";